import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=fc839bf0&"
import script from "./Passenger.vue?vue&type=script&lang=js&"
export * from "./Passenger.vue?vue&type=script&lang=js&"
import style0 from "./Passenger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports